import { render, staticRenderFns } from "./quotations-new-view.vue?vue&type=template&id=baa2eef6&"
import script from "./quotations-new-view.vue?vue&type=script&lang=js&"
export * from "./quotations-new-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports